import React, { Component } from "react";
import PropTypes from "prop-types";
import { Col, Modal, ModalBody, Row } from "reactstrap";
import { withTranslation } from "react-i18next";

class ApproveModalWithParams extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.show}
          toggle={this.props.onCloseClick}
          centered={true}
        >
          <ModalBody>
            <Row>
              <Col lg={12}>
                <div className="modal-header">
                  <i
                    className="mdi mdi-alert-circle"
                    style={{ fontSize: "3em", color: "orange" }}
                  />
                  <h5 className="modal-body" id="staticBackdropLabel">
                    {this.props.customMessage}
                  </h5>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-warning me-1"
                    onClick={this.props.onClick}
                  >
                    {this.props.t("yes")}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-1"
                    onClick={this.props.onCloseClick}
                  >
                    {this.props.t("no")}
                  </button>
                </div>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

ApproveModalWithParams.propTypes = {
  onCloseClick: PropTypes.func,
  customMessage: PropTypes.any,
  onClick: PropTypes.func,
  show: PropTypes.any,
  t: PropTypes.any,
};

export default withTranslation()(ApproveModalWithParams);
